import { DateTime } from 'luxon';
import { UpdateAssigneeDto } from '../../commonTypes/project.types';

export const EFFECTIVE_FROM_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export type IntervalApiResult = string | undefined | 'AFTER_MAX_DATE';

function dateToYmd(date: Date | null | undefined): string | undefined {
    if (!date || isNaN(date.getTime())) {
        return undefined;
    }

    const ymd = DateTime.fromJSDate(date, { zone: 'local' }).toFormat('yyyy-MM-dd');
    return EFFECTIVE_FROM_DATE_PATTERN.test(ymd) ? ymd : undefined;
}

export function intervalDateToApiString(date: Date | null | undefined, maxYmdUtc?: string): IntervalApiResult {
    const ymd = dateToYmd(date);
    if (!ymd) {
        return undefined;
    }

    if (maxYmdUtc && ymd > maxYmdUtc) {
        return 'AFTER_MAX_DATE';
    }

    return ymd;
}

export function buildUpdateAssigneeBody(
    base: Pick<UpdateAssigneeDto, 'rate' | 'rateType' | 'billable' | 'employmentType' | 'currencyCode' | 'startDate'>,
    interval?: { compensationIntervalStart?: string; compensationIntervalEnd?: string }
): UpdateAssigneeDto {
    return interval ? { ...base, ...interval } : { ...base };
}
